import "../../config.js";
import React, { useState } from 'react';
import AppHeader from '../header/AppHeader.js';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import QRCode from 'qrcode.react';
const AppMyQrcode = (props) => {
    const [qrcodeContext, setQrcodeContext] = useState(global.constants.const_url);
    return (
        <div>
            <AppHeader appHeaderTitle={global.constants.const_home_qrcode_name} appHeaderUrl={global.constants.const_url} />
            <Grid container spacing={0} >
                <Grid item xs={12}>
                    <List><ListItem></ListItem></List>
                </Grid>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" alignItems="center" spacing={3} >
                        <Grid item>
                            <QRCode value={qrcodeContext}
                                size={200}
                                fgColor="#000000"
                                level="M"
                            />
                        </Grid>
                    </Grid>
                </Grid>            
            </Grid>
        </div>
    );
}

export default () => <AppMyQrcode />;

